import React from 'react';
import ReactMarkdown from 'react-markdown';
import { twMerge } from 'tailwind-merge';

const BigText = ({ children, className = '', light, card, full, markless }) => {
  return (
    <div
      className={twMerge(
        'text-left font-title font-normal',
        full ? '' : 'lg:max-w-[600px]',
        card
          ? 'text-3xl lg:text-4xl leading-[1.1]'
          : 'text-[22px] lg:text-3xl tracking-[.22] lg:tracking-[.3] leading-snug ',
        light ? 'text-white' : 'text-new-dark-75',
        className,
      )}
    >
      {markless ? children : <ReactMarkdown>{children}</ReactMarkdown>}
    </div>
  );
};

export default BigText;
